import script from "./VolumeProfileTool.vue?vue&type=script&lang=js"
export * from "./VolumeProfileTool.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__